import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/halloween/bg/bg_witch_welcome_modal.png")